import React, { useEffect, useRef, useState } from "react";
import SubjectBoxHW from "./SubjectBoxHW";
import axios from "../../../../../axios";
import { SubjectIcon } from "../../../../../SubjectIcon";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SubjBoxPropsHW = ({ filter }) => {
  const [variable, setVariable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const scrollContainerRef = useRef(null);

  const checkOverflow = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsOverflowing(container.scrollWidth > container.clientWidth);
    }
  };

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 400, behavior: "smooth" });
  };

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -400, behavior: "smooth" });
  };

  useEffect(() => {
    const Teacher_id = localStorage.getItem("Teacher_id");
    const timetableSessionId = localStorage.getItem("timeTableSessionId");
    const timeTable_Json = JSON.parse(timetableSessionId);
    const academicSessionId = localStorage.getItem("academicYearSessionId");
    const academicSession_Json = JSON.parse(academicSessionId);
    const Teacher_Json = JSON.parse(Teacher_id);

    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/api/v1/homework/teacherSummary/get/teacherId/${Teacher_Json}?timetableSessionId=${timeTable_Json}&standardId=${filter.standard_id}&sectionId=${filter.section_id}&academicSessionId=${academicSession_Json}`,
        );
        setVariable(response.data.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (Teacher_Json !== null) {
      fetchData();
    }
  }, [filter.standard_id, filter.section_id]);

  useEffect(() => {
    const handleResize = () => checkOverflow();
    // Delay checking to wait for DOM rendering
    const timer = setTimeout(() => checkOverflow(), 200);

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [variable]);

  return (
    <div
      className="publish_summery_container gap-3 mb-2 mt-2"
      style={{
        width: "auto",
        backgroundColor: "#f2f2f2",
        overflowX: "auto",
        overflowY: "hidden",
      }}
    >
      {loading ? (
        <div className="text-center w-100 py-4">
          <div className="spinner-border text-warning" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div
          ref={scrollContainerRef}
          className="publish_summery_container mb-4 gap-3 d-flex position-relative"
          style={{
            overflowX: "auto",
            scrollBehavior: "smooth",
            alignItems: "center",
            position: "relative",
          }}
        >
          {isOverflowing && (
            <button
              type="button"
              className="btn btn-light d-flex align-items-center justify-content-center shadow"
              onClick={scrollLeft}
              style={{
                position: "sticky",
                left: 0,

                top: "50%",
                transform: "translateY(-50%)",
                borderRadius: "50%",
                backgroundColor: "#FDEFE3",
                width: "40px",
                height: "40px",
                border: "1px solid #4B4B4B",
              }}
            >
              <ChevronLeft color="#4B4B4B" size={24} />
            </button>
          )}

          {/* Scrollable Content */}
          {variable?.map((obj, index) => (
            <SubjectBoxHW
              key={index}
              subname={obj?.subject?.name}
              sublogo={
                SubjectIcon.find((i) => i.subjectName === obj?.subject?.name)
                  ?.icon || "/subIcon/ic_png_science.png"
              }
              started={obj?.not_started}
              progress={obj?.on_review}
              complateed={obj?.completed}
            />
          ))}

          {isOverflowing && (
            <button
              type="button"
              className="btn btn-light d-flex align-items-center justify-content-center shadow"
              onClick={scrollRight}
              style={{
                position: "sticky",
                right: 0,
                zIndex: 0,
                top: "50%",
                transform: "translateY(-50%)",
                borderRadius: "50%",
                backgroundColor: "#FDEFE3",
                width: "40px",
                height: "40px",
                border: "1px solid #4B4B4B",
              }}
            >
              <ChevronRight color="#4B4B4B" size={24} />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SubjBoxPropsHW;
